<template>
    <div class="ObjectGroup">
        <div class="ObjectGroup__title" v-if="title">{{title}}</div>
        <div class="ObjectGroup__object" v-for="object of objects" :key="object.id">
            <ObjectPreview v-bind="object"/>
        </div>
    </div>
</template>

<script>
import ObjectPreview from "@/components/Object/ObjectPreview";

export default {
    name: "ObjectGroup",
    components: {
        ObjectPreview,
    },
    props: {
        title: String,
        objects: Array,
    }
}
</script>

<style lang="scss">
.ObjectGroupListPage {
    padding-top: 30px;//130px;
}

.ObjectGroup {

  & + & {
    margin-top: 60px;

    @include tablet {
      margin-top: 40px;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 500;
    margin-top: 26px;
    margin-bottom: 10px;
  }

  &__object {

    & + & {
      margin-top: 24px;

      @include tablet {
        margin-top: 16px;
      }
    }
  }
}
</style>